export const IS_MOBILE = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
export const GLOBAL_BIT_NUM = 16;
export const ADMIN_VALUE = '1'.padStart(GLOBAL_BIT_NUM, '1');
